/**
 * Customer Portal I18n Provider
 * Wraps shared I18nProvider with customer-specific configuration
 */

import type { ReactNode } from 'react'
import { I18nProvider as SharedI18nProvider } from '@spcc/core'
import { LocaleProvider } from '@spcc/i18n/locale-context.tsx'
import i18n from '@/lib/i18n'

export function I18nProvider({ children }: { children: ReactNode }) {
  return (
    <SharedI18nProvider i18n={i18n} wrapper={LocaleProvider}>
      {children as any}
    </SharedI18nProvider>
  )
}
